import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import TeamMembersEdit from './TeamMembersEdit';
import { floatFormat } from '../../utils';
import PlanModal from '../UserPlan/PlanModal';
import {
  getSubscriptionType,
  getSubWorkTypeNameById,
  getOwnershipOptionByWorkType,
} from '../../utils';
import { COST_SINGLE_AGREEMENT } from '../../constants';

class CreateAgreementOwnershipPercentage extends Component {
  constructor() {
    super();
    this.state = {
      members: [],
      paywallOpen: false,
      premium: false,
      planModalOpen: false,
      isPremiumExpired: false,
      nextCollaborator: null,
      currentMemeber: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status, agreement } = nextProps;

    if (this.props.status === actionTypes.AGREEMENT_CREATE_REQUEST) {
      if (status === actionTypes.AGREEMENT_CREATE_SUCCESS) {
        if (agreement.type === 'premium') {
          this.props.router.push('/create/agreement-terms');
        } else {
          this.props.router.push('/create/review/agreement-detail');
        }
      } else if (status === actionTypes.AGREEMENT_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    }
  }

  handlePrevPage() {
    const { params, fields } = this.props;

    if (fields.soundRecordingType === 'revenue') {
      this.props.router.push(
        `/create/agreement-sound-recording-split-type/${params.page}`
      );
      return;
    }

    if (params.page === 'split') {
      this.props.router.push('/create/agreement-ownership-split');
    } else if (params.page === 'premium-split') {
      this.props.router.push('/create/agreement-ownership-premium-split');
    }
  }

  processTeamData() {
    const { fields, ownershipTypes } = this.props;
    let { members, currentMemeber } = this.state;

    if (members) {
      let sum = 0;
      const memberPublishers = [];

      let hasOwnership = true;
      let ownershipMember = null;
      let hasPercentage = true;
      let percentageMember = null;
      const ownershipOption = getOwnershipOptionByWorkType(
        fields.type,
        fields.subtype,
        ownershipTypes
      );

      if (!currentMemeber) {
        currentMemeber = members[0];
      }

      members.forEach((member) => {
        if (member.ownership && member.ownership.percentage) {
          sum += parseFloat(member.ownership.percentage, 10);
        }
      });

      sum = parseFloat(floatFormat(sum), 10);

      members.forEach((member) => {
        if (member.publishers && member.publishers.length) {
          memberPublishers.push(member);
        }

        if (member.ownership) {
          if (member.ownership.percentage && sum !== 100) {
            if (member.ownership.percentage === '0.00') {
              if (member.user === currentMemeber.user) {
                hasPercentage = false;
              } else {
                if (!percentageMember) {
                  percentageMember = member;
                }
              }
            }
          }

          if (member.ownership.ownership_type === 0) {
            if (member.user === currentMemeber.user) {
              hasOwnership = false;
            } else {
              if (!ownershipMember) {
                ownershipMember = member;
              }
            }
          } else {
            // Ignore ownership set in team profile
            if (member.ownership.ownership_type !== 1) {
              // If it's not NoOwnership
              if (member.ownership.ownership_type !== ownershipOption.id) {
                if (member.user === currentMemeber.user) {
                  hasOwnership = false;
                } else {
                  if (!ownershipMember) {
                    ownershipMember = member;
                  }
                }
              }
            }
          }
        } else {
          if (member.user === currentMemeber.user) {
            hasOwnership = false;
          } else {
            if (!ownershipMember) {
              ownershipMember = member;
            }
          }
        }
      });

      if (!hasOwnership) {
        this.props.alert(
          'error',
          'Please select an ownership type for each collaborator.'
        );
        return false;
      }

      if (ownershipMember) {
        this.setState({
          nextCollaborator: ownershipMember,
          currentMemeber: ownershipMember,
        });
        return false;
      }

      if (!hasPercentage) {
        this.props.alert(
          'error',
          'The ownership splits must total 100% before you can continue.'
        );
        return false;
      }

      if (percentageMember) {
        this.setState({
          nextCollaborator: percentageMember,
          currentMemeber: percentageMember,
        });
        return false;
      }

      if (sum !== 100) {
        this.props.alert(
          'error',
          'The ownership splits must total 100% before you can continue.'
        );
        return false;
      }
    }

    return true;
  }

  handleNextPage() {
    const { params } = this.props;

    this.setState({ nextCollaborator: null }, () => {
      if (!this.processTeamData()) {
        return;
      }

      if (params.page === 'split') {
        this.handleOpenPaywall();
      } else if (params.page === 'premium-split') {
        this.handlePremiumOwnership(true);
      }
    });
  }

  handleOpenPaywall() {
    this.setState({ paywallOpen: true });
  }

  handleClosePaywall() {
    this.setState({ paywallOpen: false });
  }

  onEnter = () => {};

  handlePremiumOwnership(val) {
    this.setState({ premium: val }, () => {
      this.handleNext();
    });
  }

  handleNext() {
    const { team, profile, fields, params, subscription } = this.props;
    const { members, premium } = this.state;

    this.props.hideAlert();

    if (members) {
      const memberPublishers = [];

      members.forEach((member) => {
        if (member.publishers && member.publishers.length) {
          memberPublishers.push(member);
        }
      });

      const workOwnerships = members.map((member) => {
        if (member.default === true) {
          this.props.updateOwnership({
            id: member.ownership.id,
            team: team.id,
            team_user: member.id,
            ownership_type: member.ownership.ownership_type,
            percentage: floatFormat(member.ownership.percentage),
          });
        }

        return {
          user: member.user,
          role_ids: member.role_ids,
          ownership_type: member.ownership.ownership_type,
          percentage: floatFormat(member.ownership.percentage),
        };
      });

      this.props.setWorkOwnerships(workOwnerships);
      this.props.assignAttribute('memberPublishers', memberPublishers);
    }

    this.props.selectAgreement({
      name:
        params.page === 'split' ? fields.splitName : fields.premiumSplitName,
      team: team.id,
      user: profile.id,
      type: premium ? 'premium' : 'split',
    });

    const subscriptionPlan = this.props.profile.subscription_plan;
    const { planType } = getSubscriptionType(subscriptionPlan, subscription);

    if (premium) {
      if (planType === 'free') {
        this.setState({ planModalOpen: true, isPremiumExpired: false });
      } else {
        if (
          subscriptionPlan === 'premium' &&
          this.props.profile.trial_expired === true
        ) {
          // Show upgrade modal for expired premium user
          this.setState({ planModalOpen: true, isPremiumExpired: true });
        } else {
          this.props.router.push(
            `/create/agreement-terms/ownership/${params.page}`
          );
        }
      }
    } else {
      this.props.router.push('/create/review/agreement-ownership-split');
    }
  }

  renderPaywall() {
    return (
      <Modal
        dialogClassName="premium-paywall"
        show={this.state.paywallOpen}
        onEnter={this.onEnter}
        onHide={() => this.handleClosePaywall()}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Hey, you might hit a brick wall later if you don't take this extra
            step now.
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Upgrade to a premium ownership agreement now and choose:
          <ul>
            <li>Which collaborators can license or sell your content.</li>
            <li>How collaborators can use each other's name and image.</li>
            <li>What rights you will have if things go wrong.</li>
          </ul>
          <p>
            Figuring this out now can save you the time, money, and frustration
            of having to fight about it in the future.
            <br />
            You've already given us more than half of the information we need to
            upgrade you.
          </p>
          <div>
            <span>
              <b>
                Do you want to upgrade to a premium ownership agreement now?{' '}
              </b>
              <span>
                &nbsp;It only costs ${parseInt(COST_SINGLE_AGREEMENT, 10) - 10}{' '}
                now (free for annual subscribers) and could save you thousands
                (if not more) later.
              </span>
            </span>
          </div>
          <div className="buttons">
            <button
              className="negative"
              onClick={() => this.handlePremiumOwnership(false)}
            >
              <b>No thanks</b>
            </button>
            <button onClick={() => this.handlePremiumOwnership(true)}>
              Let's go!
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  hidePlanModal = (type) => {
    this.setState({ planModalOpen: false }, () => {
      if (type) {
        this.props.router.push(
          '/create/agreement-terms/ownership/premium-split'
        );
      }
    });
  };

  getHeading = () => {
    const { fields, params } = this.props;

    if (fields.soundRecordingType === 'revenue') {
      return 'Propose Revenue Splits';
    }

    if (parseInt(fields.subtype, 10) === 1) {
      // selected "Sound Recording"
      return 'Propose Copyright Ownership Splits';
    }

    if (params.page === 'split') {
      return 'Propose Copyright Ownership Splits';
    } else {
      return 'Propose Copyright Ownership Premium Splits';
    }
  };

  getTitle = () => {
    const { fields, params } = this.props;

    if (fields.soundRecordingType === 'revenue') {
      return 'revenue split';
    }

    if (parseInt(fields.subtype, 10) === 1) {
      // selected "Sound Recording"
      return 'split';
    }

    if (params.page === 'split') {
      return 'split';
    } else {
      return 'premium split';
    }
  };

  setCurrentMember = (member) => {
    this.setState({ currentMemeber: member });
  };

  render() {
    const { subscription, profile, fields, subWorkTypes, members } = this.props;
    const { planModalOpen, isPremiumExpired } = this.state;

    let subWorkTypeName = 'musical composition';
    if (fields.subtype) {
      subWorkTypeName = getSubWorkTypeNameById(fields.subtype, subWorkTypes);
    }

    return (
      <div className="create-agreement">
        <Heading text={this.getHeading()} />

        <div className="content">
          <p className="text-gray">
            A {this.getTitle()} is the percentage of the copyright for the{' '}
            {subWorkTypeName.toLocaleLowerCase()} that each collaborator will
            own. Click on each collaborator's name below to propose their split
            for the work(s). The{' '}
            {parseInt(fields.subtype, 10) === 1 ? '' : 'ownership'} splits must
            total 100% before you can continue.
          </p>

          <p className="text-gray">
            {parseInt(fields.subtype, 10) === 1 ? (
              <strong>
                Need to change a collaborator’s role? Click on "Teams" to find
                and change your collaborator's information.
              </strong>
            ) : (
              <strong>
                Need to change a collaborator’s role? Click on "Teams" to find
                and change your collaborator's information.
              </strong>
            )}
          </p>

          {this.props.team && (
            <TeamMembersEdit
              team={this.props.team.id}
              members={members}
              soundRecordingType={fields.soundRecordingType}
              nextCollaborator={this.state.nextCollaborator}
              onUpdateMembers={(members) => this.setState({ members })}
              setCurrentMember={this.setCurrentMember}
            />
          )}
        </div>

        {this.renderPaywall()}

        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrevPage()} />
          {members.length > 0 && (
            <NavButtons direction="next" next={() => this.handleNextPage()} />
          )}
        </div>

        <PlanModal
          show={planModalOpen}
          subscriptionPlan={profile.subscription_plan}
          referrer={profile.referrer}
          // showCheckoutStep={isPremiumExpired}
          isPremiumExpired={isPremiumExpired}
          showAllPlan={isPremiumExpired}
          agreementType={1}
          isCanceledSubscription={
            subscription &&
            subscription.status === 'Canceled' &&
            profile.subscription_plan === 'free'
          }
          hidePlanModal={this.hidePlanModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  profile: state.profile,
  team: state.teams.selectedTeam,
  members: state.users.members,
  status: state.agreements.status,
  error: state.agreements.error,
  agreement: state.agreements.selectedAgreement,
  subscription: state.payment.subscription,
  subWorkTypes: state.global.subWorkTypes,
  ownershipTypes: state.global.ownershipTypes,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  updateOwnership: (ownership) => {
    dispatch(actions.updateMemberOwnership(ownership));
  },
  selectAgreement: (data) => {
    dispatch(actions.selectAgreement(data));
  },
  setWorkOwnerships: (workOwnerships) => {
    dispatch(actions.setWorkOwnerships(workOwnerships));
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAgreementOwnershipPercentage);



// WEBPACK FOOTER //
// src/components/Agreements/CreateAgreementOwnershipPercentage.jsx